module.exports = __webpack_public_path__ + "img/机械臂失控.4d5c0881.png";